import {
  AB_TEST_LOCALES_MAP,
  COHORT_FIREBASE_KEYS_MAP,
  COHORT_GROWTHBOOK_KEYS_MAP,
  DEFAULT_AB_TEST_LOCALES,
  PAUSED_AB_TEST_KEYS,
  TAbTestKey,
} from 'nove8/constants/ab-tests'
import { Cohort } from 'nove8/constants/root-constants'
import { getIsMetaSource } from 'nove8/helpers/getIsMetaSource'
import { getMobileOperatingSystem } from 'nove8/helpers/getMobileOperatingSystem'
import {
  Countries,
  FirebaseRemoteConfigKey,
  GrowthbookKey,
  PlatformOS,
  WOOFZ_22_V4,
} from 'root-constants'

const toKeysArray = (
  keys: TAbTestKey | TAbTestKey[] | undefined,
): TAbTestKey[] => {
  if (!keys) return []
  return Array.isArray(keys) ? keys : [keys]
}

export const getFilteredCohortAbTestKeys = (
  cohort: Cohort | string,
  country: Countries,
  language?: string,
): TAbTestKey[] => {
  const keysArray = [
    ...toKeysArray(COHORT_FIREBASE_KEYS_MAP[cohort as Cohort]),
    ...toKeysArray(COHORT_GROWTHBOOK_KEYS_MAP[cohort as Cohort]),
  ]
  const isMetaSource = getIsMetaSource()
  if (!keysArray.length) return []
  let filteredKeys = keysArray

  const shouldHideRoverPartnership2 =
    cohort === WOOFZ_22_V4 && country !== Countries.US
  const shouldHideSubPlansPwUs =
    cohort === Cohort.WOOFZ_LOVE_BL && country !== Countries.US
  const shouldHideBrazilPr =
    cohort === Cohort.WOOFZ_LOVE_BL && country !== Countries.BR
  const shouldHideSignUpChangesK9 =
    Cohort.WOOFZ_K9 === cohort && getMobileOperatingSystem() !== PlatformOS.IOS
  const shouldHideSignUpChangesK9BL =
    Cohort.WOOFZ_K9_BL === cohort &&
    getMobileOperatingSystem() !== PlatformOS.IOS
  const shouldHideOtpUpsellUsK9Bl =
    cohort === Cohort.WOOFZ_K9_BL && !(isMetaSource && country === Countries.US)
  const shouldHideOtpUpsellUsK9 =
    cohort === Cohort.WOOFZ_K9 && !(isMetaSource && country === Countries.US)
  const shouldHideOtpUpsellUsPppBl =
    cohort === Cohort.WOOFZ_PPP_BL &&
    !(isMetaSource && country === Countries.US)

  filteredKeys = filteredKeys.filter(
    (key) => !PAUSED_AB_TEST_KEYS.includes(key),
  )

  if (shouldHideRoverPartnership2) {
    filteredKeys = filteredKeys.filter(
      (key) =>
        key !== FirebaseRemoteConfigKey.ABTEST_WEB_2674_ROVER_PARTNERSHIP2,
    )
  }

  if (shouldHideSubPlansPwUs) {
    filteredKeys = filteredKeys.filter(
      (key) => key !== FirebaseRemoteConfigKey.ABTEST_WEB_2747_SUB_PLANS_PW,
    )
  }

  if (shouldHideBrazilPr) {
    filteredKeys = filteredKeys.filter(
      (key) => key !== GrowthbookKey.ABTEST_WEB_2763_BRAZIL_PR,
    )
  }

  if (shouldHideSignUpChangesK9) {
    filteredKeys = filteredKeys.filter(
      (key) =>
        key !== FirebaseRemoteConfigKey.ABTEST_WEB_2844_SOCIAL_SIGN_UP_K9,
    )
  }

  if (shouldHideSignUpChangesK9BL) {
    filteredKeys = filteredKeys.filter(
      (key) =>
        key !== FirebaseRemoteConfigKey.ABTEST_WEB_2844_SOCIAL_SIGN_UP_K9_BL,
    )
  }

  if (shouldHideOtpUpsellUsK9Bl) {
    filteredKeys = filteredKeys.filter(
      (key) => key !== GrowthbookKey.ABTEST_WEB_2904_ONE_TIME_UPSELL,
    )
  }

  if (shouldHideOtpUpsellUsK9) {
    filteredKeys = filteredKeys.filter(
      (key) => key !== GrowthbookKey.ABTEST_WEB_2906_ONE_TIME_UPSELL,
    )
  }

  if (shouldHideOtpUpsellUsPppBl) {
    filteredKeys = filteredKeys.filter(
      (key) => key !== GrowthbookKey.ABTEST_WEB_2907_ONE_TIME_UPSELL,
    )
  }

  if (language) {
    filteredKeys = filteredKeys.filter((key) => {
      const allowedLocales = AB_TEST_LOCALES_MAP[key]
      if (allowedLocales === null) return true
      return (allowedLocales || DEFAULT_AB_TEST_LOCALES).includes(language)
    })
  }

  return filteredKeys
}
